/* RUQA product page behaviour: gallery, option tabs, variant matching, add-ons, finance lines, delivery timeline. */
(function () {
  var root = document.querySelector('[data-ruqa-pdp]');
  var dataEl = document.getElementById('ruqa-pdp-data');
  if (!root || !dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var form = document.getElementById('ruqa-pdp-form');
  var idInput = document.getElementById('ruqa-variant-id');
  var atc = document.getElementById('ruqa-atc');
  var addons = { base: false, assembly: false };

  function money(c) {
    var n = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return data.money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }
  function delta(c) {
    var v = c / 100;
    return '+£' + v.toFixed(2);
  }

  /* ---------- gallery (Splide) ---------- */
  var mainSplide = null;
  if (window.Splide && root.querySelector('.pdp-img-main-splide')) {
    mainSplide = new Splide('.pdp-img-main-splide', { type: 'fade', rewind: true, pagination: true, arrows: false });
    var gEl = root.querySelector('.pdp-img-gallery-splide');
    var gSplide = null;
    if (gEl && window.matchMedia('(min-width: 1024px)').matches) {
      var count = gEl.querySelectorAll('.splide__slide').length, over = count > 5;
      if (!over) gEl.classList.add('pdp-gallery-static');
      gSplide = new Splide('.pdp-img-gallery-splide', { type: 'slide', perPage: 6, perMove: 1, gap: '10px', pagination: false, arrows: over, drag: over, isNavigation: true, focus: over ? 'center' : 0, breakpoints: { 1030: { gap: '4px' }, 768: { perPage: 3 }, 480: { perPage: 2 } } });
      mainSplide.sync(gSplide);
    }
    mainSplide.mount();
    if (gSplide) gSplide.mount();
  }

  /* ---------- lightbox ---------- */
  var lb = document.getElementById('pdp-lightbox-modal');
  var lbSplide = null;
  function openLightbox() {
    if (!lb) return;
    lb.classList.add('active'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    lb.querySelectorAll('.pdp-lightbox-image').forEach(function (i) { if (!i.src && i.dataset.src) i.src = i.dataset.src; });
    if (!lbSplide && window.Splide) {
      lbSplide = new Splide('.pdp-lightbox-splide', { type: 'slide', pagination: false, arrows: true, rewind: true });
      lbSplide.on('move', function (n) { var c = lb.querySelector('.pdp-lightbox-counter'); if (c) c.textContent = (n + 1) + ' / ' + lbSplide.length; });
      lbSplide.mount();
    }
    if (lbSplide && mainSplide) lbSplide.go(mainSplide.index);
  }
  function closeLightbox() { if (!lb) return; lb.classList.remove('active'); lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  var exp = document.getElementById('pdp-expand-trigger');
  if (exp) exp.addEventListener('click', openLightbox);
  var mainBox = root.querySelector('.pdp-img-main-splide');
  if (mainBox) mainBox.addEventListener('click', openLightbox);
  if (lb) {
    lb.querySelector('.pdp-lightbox-close').addEventListener('click', closeLightbox);
    lb.querySelector('.pdp-lightbox-overlay').addEventListener('click', closeLightbox);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeLightbox(); closeDims(); } });

  /* ---------- dimensions modal ---------- */
  var dm = document.getElementById('ruqa-dims-modal');
  function closeDims() { if (dm) { dm.classList.remove('active'); dm.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  root.querySelectorAll('[data-ruqa-dims]').forEach(function (b) { b.addEventListener('click', function () { dm.classList.add('active'); dm.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }); });
  if (dm) dm.querySelectorAll('[data-close-dims]').forEach(function (b) { b.addEventListener('click', closeDims); });


  /* ---------- single-variant products: short description toggle + quantity stepper ---------- */
  root.querySelectorAll('[data-ruqa-see-more]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var box = a.closest('[data-ruqa-short-desc]'); if (box) box.classList.toggle('expanded'); });
  });
  var qIn = root.querySelector('[data-ruqa-qty-input]');
  var qty = function () { return qIn ? Math.max(1, Math.min(99, parseInt(qIn.value, 10) || 1)) : 1; };
  if (qIn) {
    var qm = root.querySelector('[data-ruqa-qty-minus]'), qp = root.querySelector('[data-ruqa-qty-plus]');
    if (qm) qm.addEventListener('click', function () { qIn.value = Math.max(1, qty() - 1); });
    if (qp) qp.addEventListener('click', function () { qIn.value = Math.min(99, qty() + 1); });
    qIn.addEventListener('change', function () { qIn.value = qty(); });
  }

  /* ---------- tabs ---------- */
  var tabs = root.querySelectorAll('.filter-bar .filter-item');
  function showTab(key) {
    tabs.forEach(function (t) { var on = t.dataset.filter === key; t.classList.toggle('active', on); t.classList.remove('filter-hidden'); });
    root.querySelectorAll('.section-content').forEach(function (s) { s.classList.toggle('hidden', s.dataset.section !== key); });
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () { showTab(t.dataset.filter); });
    t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showTab(t.dataset.filter); } });
  });
  /* the Sonno layout shows every tab; inactive ones are not hidden */
  tabs.forEach(function (t) { t.classList.remove('filter-hidden'); });
  /* on phones the Colour tab is replaced by the swatch strip, so open the first visible tab instead */
  (function () { var fv = Array.prototype.find.call(tabs, function (t) { return t.offsetParent !== null; }); if (fv && !fv.classList.contains('active')) showTab(fv.dataset.filter); })();

  /* ---------- variants ---------- */
  var grids = root.querySelectorAll('.options-grid[data-option-index], .variant-pill-row[data-option-index]');
  function current() {
    var sel = [];
    grids.forEach(function (g) { var s = g.querySelector('.option-item.selected, .variant-pill.selected'); sel[+g.dataset.optionIndex] = s ? s.dataset.value : null; });
    return sel;
  }
  function findVariant(sel) {
    return data.variants.find(function (v) { return sel.every(function (o, i) { return v.options[i] === o; }); });
  }
  /* when the exact combination does not exist (e.g. foot-end drawers on a small single), fall back to the closest variant that has the chosen value, cheapest first */
  function resolve(sel, oi) {
    var exact = findVariant(sel); if (exact) return exact;
    var pool = data.variants.filter(function (v) { return v.options[oi] === sel[oi]; });
    if (!pool.length) return null;
    var score = function (v) { return sel.reduce(function (n, o, i) { return n + (v.options[i] === o ? 1 : 0); }, 0); };
    pool.sort(function (a, b) { return score(b) - score(a) || a.price - b.price; });
    return pool[0];
  }
  function variantById(id) { return data.variants.find(function (v) { return v.id === id; }); }
  function sizeIndex() { return data.options.findIndex(function (n) { return /size/i.test(n); }); }
  function sizeMatch(list, sizeName) {
    var up = (sizeName || '').toUpperCase();
    return list.find(function (v) { return (v.option1 || v.title || '').toUpperCase().indexOf(up) === 0 || (v.title || '').toUpperCase() === up; }) || list[0];
  }
  function currentSizeName() {
    var si = sizeIndex(), sel = current();
    return si > -1 ? sel[si] : '';
  }
  function extraBase() {
    if (!addons.base || !data.reinforced.length) return null;
    return sizeMatch(data.reinforced, currentSizeName());
  }
  function totalPrice(v) { return v.price + (addons.base && extraBase() ? extraBase().price : 0); }

  function render() {
    var sel = current();
    var v = findVariant(sel);
    if (!v) { if (atc) { atc.disabled = true; atc.querySelector('span').textContent = data.soldOut; } return; }
    if (idInput) idInput.value = v.id;
    // tab values
    tabs.forEach(function (t) {
      var idx = t.dataset.optionIndex; var out = t.querySelector('[data-selected-value]');
      if (idx !== undefined && out) out.textContent = sel[+idx];
    });
    // prices (bed + reinforced base when chosen)
    var price = totalPrice(v);
    var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price + (price - v.price) : 0;
    var set = function (id, txt) { var e = document.getElementById(id); if (e) e.textContent = txt; };
    set('currentPrice', money(price));
    var cp = document.getElementById('comparePrice'), sv = document.getElementById('savingsAmount');
    if (cp) { if (compare > price) { cp.textContent = money(compare); cp.hidden = false; } else cp.hidden = true; }
    if (sv) { if (compare > price) { sv.innerHTML = '<strong>' + Math.round((compare - price) * 100 / compare) + '%</strong>&nbsp;OFF'; sv.hidden = false; } else sv.hidden = true; }
    // deltas next to each option value
    grids.forEach(function (g) {
      var oi = +g.dataset.optionIndex;
      g.querySelectorAll('.option-item, .variant-pill').forEach(function (li) {
        var test = sel.slice(); test[oi] = li.dataset.value;
        var tv = resolve(test, oi), pEl = li.querySelector('.option-price');
        if (pEl) pEl.textContent = (tv && tv.price > v.price) ? delta(tv.price - v.price) : '';
      });
    });
    var rb = root.querySelector('[data-base-price]');
    if (rb && data.reinforced.length) { var r = sizeMatch(data.reinforced, currentSizeName()); rb.textContent = r ? delta(r.price) : ''; }
    // state for other sections (dimensions)
    var si2 = data.options.findIndex(function (n) { return /size/i.test(n); }), hi2 = data.options.findIndex(function (n) { return /headboard/i.test(n); });
    var fi2 = data.options.findIndex(function (n) { return /firm/i.test(n); });
    window.pdpState = { size: si2 > -1 ? sel[si2] : '', headboard: hi2 > -1 ? sel[hi2] : 'None', firmness: fi2 > -1 ? sel[fi2] : '' };
    window.dispatchEvent(new Event('sonno:pdpStateChanged'));
    root.querySelectorAll('[data-option-label]').forEach(function (el) { el.textContent = sel[+el.dataset.optionLabel] || ''; });
    // mattress size card: label + width/length
    var szl = root.querySelector('[data-ruqa-size-label]');
    if (szl) {
      szl.textContent = sel[0];
      var sli = root.querySelector('[data-ruqa-mattress] .option-item.selected');
      var ww = root.querySelector('[data-ruqa-width]'), ll = root.querySelector('[data-ruqa-length]');
      if (sli && ww) ww.textContent = sli.dataset.width; if (sli && ll) ll.textContent = sli.dataset.length;
    }
    // availability
    if (atc) { atc.disabled = !v.available; atc.querySelector('span').textContent = v.available ? data.button : data.soldOut; }
    // gallery
    if (mainSplide && v.featured_media) {
      var slides = root.querySelectorAll('.pdp-img-main-splide .splide__slide');
      for (var i = 0; i < slides.length; i++) { if (+slides[i].dataset.mediaId === v.featured_media.id) { mainSplide.go(i); break; } }
    }
    // finance + url
    var db = root.querySelector('[data-dividebuy-monthly]'), kl = root.querySelector('[data-klarna-monthly]');
    if (db) db.textContent = money(price / 8);
    if (kl) kl.textContent = money(price / 3);
    var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
  }

  grids.forEach(function (g) {
    g.addEventListener('click', function (e) {
      var li = e.target.closest('.option-item, .variant-pill'); if (!li) return;
      g.querySelectorAll('.option-item, .variant-pill').forEach(function (x) { x.classList.remove('selected'); }); li.classList.add('selected');
      var sel = current(), oi = +g.dataset.optionIndex, rv = resolve(sel, oi);
      if (rv && !findVariant(sel)) {
        grids.forEach(function (g2) {
          var j = +g2.dataset.optionIndex; if (j === oi) return;
          g2.querySelectorAll('.option-item, .variant-pill').forEach(function (x) { x.classList.toggle('selected', x.dataset.value === rv.options[j]); });
        });
      }
      render();
    });
    g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { var li = e.target.closest('.option-item, .variant-pill'); if (li) { e.preventDefault(); li.click(); } } });
  });

  // base option
  var baseGrid = root.querySelector('#baseSection .options-grid');
  if (baseGrid) {
    baseGrid.addEventListener('click', function (e) {
      var li = e.target.closest('.option-item'); if (!li) return;
      baseGrid.querySelectorAll('.option-item').forEach(function (x) { x.classList.remove('selected'); }); li.classList.add('selected');
      addons.base = li.dataset.base === 'reinforced';
      var bv = root.querySelector('[data-base-value]'); if (bv) bv.textContent = addons.base ? 'Reinforced base' : 'Standard Base';
      render();
    });
  }
  // assembly
  var asmBtn = document.getElementById('addAssemblyBtn');
  if (asmBtn) asmBtn.addEventListener('click', function () {
    addons.assembly = !addons.assembly; asmBtn.textContent = addons.assembly ? 'Remove' : 'Add';
  });

  /* ---------- mattress drawer ("Add Mattress & Save") ---------- */
  var mm = { box: root.querySelector('[data-ruqa-mattress-addon]'), list: [], firm: '', pick: null };
  (function () {
    if (!mm.box) return;
    var jEl = mm.box.querySelector('[data-mm-json]');
    try { mm.list = JSON.parse(jEl.textContent); } catch (e) { mm.list = []; }
    if (!mm.list.length) return; // no data: "Choose Mattress" stays a plain link to the collection
    var host = mm.box.querySelector('.ruqa-mm-host');
    document.body.appendChild(host); // out of the section so the fixed drawer sits above the header
    var drawer = host.querySelector('[data-mm-drawer]'), tabsEl = drawer.querySelector('[data-mm-tabs]'), listEl = drawer.querySelector('[data-mm-list]');
    var empty = mm.box.querySelector('[data-mm-empty]'), selBox = mm.box.querySelector('[data-mm-selected]');
    var norm = function (t) { return String(t || '').trim().toLowerCase(); };
    var firms = [];
    mm.list.forEach(function (m) { m.firmness = m.firmness.map(function (f) { return f.trim(); }).filter(Boolean); m.firmness.forEach(function (f) { if (firms.indexOf(f) < 0) firms.push(f); }); });
    mm.firm = firms[0] || '';
    function variantFor(m, size, firm) {
      var vs = m.variants.filter(function (v) { return v.options.some(function (o) { return norm(o) === norm(size); }); });
      if (!vs.length) vs = m.variants.filter(function (v) { return norm(v.title).indexOf(norm(size)) === 0; });
      var byFirm = vs.filter(function (v) { return v.options.some(function (o) { return norm(o) === norm(firm); }); });
      if (byFirm.length) vs = byFirm;
      return vs.find(function (v) { return v.available; }) || null;
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function openDrawer() { drawTabs(); drawList(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
    function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }
    function drawTabs() {
      tabsEl.innerHTML = firms.map(function (f) { return '<li><button type="button" class="ruqa-mm-tab' + (f === mm.firm ? ' active' : '') + '" data-firm="' + esc(f) + '">' + esc(f) + '</button></li>'; }).join('');
    }
    function drawList() {
      var size = currentSizeName(), html = '';
      mm.list.forEach(function (m) {
        if (mm.firm && m.firmness.indexOf(mm.firm) < 0) return;
        var v = variantFor(m, size, mm.firm); if (!v) return;
        var on = mm.pick && mm.pick.m === m && mm.pick.v.id === v.id;
        html += '<button type="button" class="ruqa-mm-card' + (on ? ' active' : '') + '" data-handle="' + esc(m.handle) + '" data-vid="' + v.id + '">' +
          '<span class="ruqa-mm-card-img"><img src="' + esc(v.image || m.image) + '" alt="' + esc(m.title) + '" width="86" height="80" loading="lazy"><span class="ruqa-mm-radio"></span></span>' +
          '<span class="ruqa-mm-card-body"><span class="ruqa-mm-card-title text-gray">' + esc(m.title) + '</span>' +
          '<span class="ruqa-mm-card-price"><b>' + money(v.price) + '</b>' + (v.compare > v.price ? '<span class="text-gray">Was: ' + money(v.compare) + '</span>' : '') + '</span>' +
          '<span class="flex item-center gap-base">' + (v.compare > v.price ? '<span class="pdp-save-price fw-medium bg-secondary text-white">SAVE: ' + money(v.compare - v.price) + '</span>' : '') +
          '<a class="ruqa-mm-link text-gray fw-medium" href="' + esc(m.url) + '?variant=' + v.id + '" target="_blank" rel="noopener" data-mm-details>See Details</a></span></span></button>';
      });
      listEl.innerHTML = html || '<p class="ruqa-mm-empty text-gray">No mattress in this firmness for the selected size.</p>';
    }
    function showPick() {
      if (!mm.pick) { selBox.hidden = true; selBox.style.display = 'none'; empty.style.display = ''; return; }
      var m = mm.pick.m, v = mm.pick.v, q = function (s) { return selBox.querySelector(s); };
      q('[data-mm-sel-img]').src = v.image || m.image; q('[data-mm-sel-img]').alt = m.title;
      q('[data-mm-sel-title]').textContent = m.title;
      q('[data-mm-sel-size]').textContent = v.title;
      q('[data-mm-sel-price]').textContent = money(v.price);
      q('[data-mm-sel-compare]').textContent = v.compare > v.price ? money(v.compare) : '';
      var save = q('[data-mm-sel-save]'); save.style.display = v.compare > v.price ? '' : 'none'; save.textContent = 'SAVE: ' + money(v.compare - v.price);
      q('[data-mm-sel-details]').href = m.url + '?variant=' + v.id;
      empty.style.display = 'none'; selBox.hidden = false; selBox.style.display = '';
    }
    mm.box.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm-open]')) { e.preventDefault(); openDrawer(); }
      else if (e.target.closest('[data-mm-remove]')) { mm.pick = null; showPick(); }
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm-close]')) { closeDrawer(); return; }
      if (e.target.closest('[data-mm-details]')) return; // opens the mattress page in a new tab
      var tab = e.target.closest('[data-firm]');
      if (tab) { mm.firm = tab.dataset.firm; drawTabs(); drawList(); return; }
      var card = e.target.closest('.ruqa-mm-card');
      if (card) {
        var m = mm.list.find(function (x) { return x.handle === card.dataset.handle; });
        var v = m && m.variants.find(function (x) { return x.id === +card.dataset.vid; });
        if (m && v) { mm.pick = { m: m, v: v, firm: mm.firm }; showPick(); closeDrawer(); }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
    // bed size changed: move the chosen mattress to the same size, or drop it if that size does not exist
    window.addEventListener('sonno:pdpStateChanged', function () {
      if (!mm.pick) return;
      var v = variantFor(mm.pick.m, currentSizeName(), mm.pick.firm);
      if (v) mm.pick.v = v; else mm.pick = null;
      showPick();
    });
  })();

  /* ---------- add to cart (bed + chosen add-ons) ---------- */
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (atc && atc.disabled) return;
    var items = [{ id: +idInput.value, quantity: qty() }];
    var rb = extraBase(); if (rb) items.push({ id: rb.id, quantity: 1 });
    if (addons.assembly && data.assembly.length) items.push({ id: sizeMatch(data.assembly, currentSizeName()).id, quantity: 1 });
    if (mm.pick) items.push({ id: mm.pick.v.id, quantity: qty() });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { form.submit(); });
  });

  /* ---------- delivery timeline ---------- */
  var fmt = function (d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }).replace(/^(\d+) (\w+)$/, '$2 $1'); };
  var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
  var q = function (s) { return root.querySelector(s); };
  if (q('[data-ds-ordered]')) {
    q('[data-ds-ordered]').textContent = fmt(add(0));
    q('[data-ds-ready]').textContent = fmt(add(4)) + ' - ' + fmt(add(8));
    q('[data-ds-delivered]').textContent = fmt(add(9)) + ' - ' + fmt(add(18));
    q('[data-ds-from]').textContent = fmt(add(9));
    q('[data-ds-to]').textContent = fmt(add(18));
  }

  render();
})();
